// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__Q9dRG","aside--noPaddin":"Aside_aside--noPaddin__zLtPr"};